export const COOKIE_CONSENT_COOKIE_NAME = 'cgp_cookie_consent';
export const COOKIE_CONSENT_PREFS_STORAGE_KEY = 'cgp_cookie_consent_prefs';

